export const setCookie = (params) => {
    const name = params.name;
    const value = params.value;
    document.cookie = name + "=" + encodeURI(value) +
        ";domain=" + window.location.hostname +
        ";path=/"
};

export function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

export const deleteCookie = (name) => {
    setCookie({name: name, value: ''});
};



// WEBPACK FOOTER //
// ./src/utils/CookieUtils.js